import { joinStrings } from "@/lib/joinString"
import { AdvancedCareProvider } from "@/modules/care-provider/advanced-search/types/AdvancedCareProvider"
import { CareProviderOption } from "@/modules/care-provider/simple-search/care-provider-search"
import { getHighlightValue } from "@/modules/care-provider/utils/get-highlight-value"
import { timeWindowReasonQuery } from "@/modules/inbound-wizard/components/ch/reason-for-call/__generated__/timeWindowReasonQuery.graphql"

type ReferralToCareProvider = NonNullable<
  timeWindowReasonQuery["response"]["ch_activeTimeWindowsWithReferralToCareProviderByPatientId"][0]["referralToCareProvider"]
>

export const getCareProviderAddress = (option: CareProviderOption | AdvancedCareProvider | ReferralToCareProvider) => {
  const highlights = "highlights" in option ? option.highlights : null
  const countryName = option.country?.countryName
  const postalCity = joinStrings(
    [
      getHighlightValue(highlights, "postalCode", option.postalCode),
      getHighlightValue(highlights, "city", option.city),
    ],
    " ",
  )

  return joinStrings(
    [getHighlightValue(highlights, "streetAddress", option.streetAddress), postalCity, countryName],
    ", ",
  )
}
